export const SEND_EMAIL_ACTION = "sendEmail";
export const GET_DRAWING_ACTION = "getDrawing";
export const GET_STREAM_LINK_ACTION = "getStreamLink";